module.exports = __webpack_public_path__ + "img/error-solid.9a0782eb.svg";